import React from 'react';
import { useSubscription } from '@apollo/react-hooks';
import gql from 'graphql-tag';

const USERS_SUBSCRIPTION = gql`
  subscription users_time_taken {
    users_time_taken(where: {time_taken: {_gt: 2}}, order_by: [{id: desc}], limit: 50) {
      name
      time_taken
    }
  }
`;

const CURRENT_WINNER_SUBSCRIPTION = gql`
  subscription currentWinner {
    users_time_taken(where: {time_taken: {_gt: 2}}, order_by: [{time_taken: asc}], limit: 1) {
      name
      time_taken
    }
  }
`;

const Leaderboard = () => {

  const { loading, error, data } = useSubscription(USERS_SUBSCRIPTION);
  const { data : currentWinner } = useSubscription(CURRENT_WINNER_SUBSCRIPTION);

  let currentWinnerElem = null;
  if(currentWinner && currentWinner.users_time_taken && currentWinner.users_time_taken[0]) {
    currentWinnerElem = (
      <div>
        <p>Current Winner - {currentWinner.users_time_taken[0].name} ({currentWinner.users_time_taken[0].time_taken}s)</p>
      </div>
    );

  }

  if(error) {
    return <p>Error..</p>
  }
  if(loading || !data) {
    return <p>Loading..</p>
  }

  const rows = data.users_time_taken.map((user, index) => {
    return (
      <tr key={index}>
        <td>{user.name}</td>
        <td>{user.time_taken > 0 ? user.time_taken : 'Waiting to complete..'}</td>
      </tr>
    );
  });

  return (
    <div className="leaderboard">
      <header className="LeaderHeader">
      <div className="leaderboardWrapper">
        <div className="logoWrapper">
          <img className="img-responsive hasuraLogo" src="data:image/svg+xml;base64,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" alt="The Hasura Logo" />
        </div>
        <div className="headerLeader">Leaderboard</div>
      </div>
      </header>
      <div className="tableBody">
        {currentWinnerElem}
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Name</th>
              <th>Time Taken (seconds)</th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Leaderboard;
